import {
    DeleteOutlined,
    FileExcelOutlined,
    InfoCircleOutlined,
    ReadOutlined
} from '@ant-design/icons';
import { Button, Card, Modal, Space, Table, Tooltip } from 'antd';

import type { ColumnsType } from 'antd/es/table';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { deleteClientesById, gerarRelatorioDeClientes, getAllClientes } from "../../../api/clientes";
import { getColumnSearchProps } from "../../../components/GetColumnSearch";
import { useLoading } from "../../../contexts/LoadingContext";
import { ClienteType } from "../../../types/ClienteTypes";
import { columnsDefs } from "../columnDefs";

export default function Geral() {
    const [data, setData] = useState<ClienteType[]>([]);
    const [selectedCliente, setSelectedCliente] = useState<any>(null);
    const [openModal, setOpenModal] = useState(false);
    const [btnLoadinButton, setBtnLoadingButton] = useState<boolean>(false);
    const [ordenacao, setOrdenacao] = useState({
        // Configuração inicial de ordenação
        columnKey: 'nome',
        order: 'ascend' as const,
    });
    const { setLoading } = useLoading();
    let navigate = useNavigate();

    const handleTableChange = (pagination: any, filters: any, sorter: any) => {
        // Atualiza o estado de ordenação quando ocorre uma mudança na tabela
        setOrdenacao({ columnKey: sorter.columnKey, order: sorter.order });
    };

    // Função de comparação personalizada para ordenar a coluna 'nome'
    // const compareNome = (a: any, b: any) => {
    //     const nomeA = a.nome.toUpperCase();
    //     const nomeB = b.nome.toUpperCase();

    //     if (ordenacao.order === 'ascend') {
    //         return nomeA.localeCompare(nomeB);
    //     } else {
    //         return nomeB.localeCompare(nomeA);
    //     }
    // };

    // Aplica a ordenação aos dados

    const columnDefsWithActions: ColumnsType<any> = [{
        title: "Nome",
        dataIndex: "nome",
        key: "nome",
        // defaultSortOrder: 'descend',
        // sorter: (a, b) => a.nome.length - b.nome.length,
        sortOrder: ordenacao.columnKey === 'nome' ? ordenacao.order : null,
        ...getColumnSearchProps('nome', 'Nome'),
    }, ...columnsDefs, {
        title: "Ações",
        key: "executar",
        render: (_: any, record: any) => (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                <Space size="middle">
                    <ReadOutlined style={{ fontSize: '20px' }} onClick={() => navigate(`/demandas/geral/cliente/${record.id}`)} />
                    <DeleteOutlined style={{ fontSize: '20px' }} onClick={() => {
                        setSelectedCliente(record);
                        showModal();
                    }
                    } />
                </Space>
            </div>
        ),
    },
    ];


    const getAllClientesfromApi = async () => {
        setLoading(true);
        const response = await getAllClientes().then((response) => {
            setData([]);
            setData(response.data);
            setLoading(false);
        });
        return response;
    }

    const handleOk = async () => {
        setBtnLoadingButton(true);
        const response = await deleteClientesById(selectedCliente.id);
        if (response) {
            getAllClientesfromApi();
            setOpenModal(false);
            setBtnLoadingButton(false);
        }
    };

    const showModal = () => {
        setOpenModal(true);
    };

    const handleCancel = () => {
        setOpenModal(false);
    };

    useEffect(() => {
        getAllClientesfromApi();
    }, []);

    return (
        <>
            <Space direction="vertical" style={{ display: 'flex' }}>
                <Card extra={<><Button loading={btnLoadinButton} type="primary"
                    icon={<FileExcelOutlined />} onClick={() => {
                        setBtnLoadingButton(true);
                        const response = gerarRelatorioDeClientes(data);
                        response.then((response) => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'relatorio_clientes.xlsx');
                            document.body.appendChild(link);
                            link.click();
                            setBtnLoadingButton(false);
                        });
                    }}>GERAR RELATÓRIO</Button></>} title={<>Lista de clientes <Tooltip placement="bottom" title="Para criar um novo cadastro de cliente, clique no botão 'Novo' no canto superior direito da tela.">
                        <InfoCircleOutlined />
                    </Tooltip></>}>
                    <Table
                        onChange={handleTableChange}
                        columns={columnDefsWithActions || []}
                        dataSource={data || []}
                        rowKey={(record) => record.id}
                        pagination={{ pageSize: 12 }}
                        size='middle'
                        // Se o status for 541ed947-12c9-401a-9902-dbd7b8884a9c pintar a linha de vermelho
                        rowClassName={(record) => record.statusClienteId === '541ed947-12c9-401a-9902-dbd7b8884a9c' ? 'red-row' : ''}
                    // onRow={(record) => ({
                    //     onClick: () => navigate(`/demandas/geral/cliente/${record.id}`),
                    // })}
                    />
                </Card>
            </Space>
            <Modal
                open={openModal}
                title="Atenção!"
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={btnLoadinButton}
                footer={(_, { OkBtn, CancelBtn }) => (
                    <>
                        <CancelBtn />
                        <OkBtn />
                    </>
                )}
            >
                <p>Você tem certeza que deseja apagar o cliente?</p>
                <p>Isso irá apagar todos os dados inclusive os anexos</p>
            </Modal>
        </>
    )
}
